import { CarouselItem } from '@/components/ui/carousel'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { useTranslation } from 'react-i18next'
import { useNeedsAnalysis } from '@/contexts/needs-analysis/NeedsAnalysisContext'
import { COMMUNICATION_CHANNELS } from '@/constants/needsAnalysis'

export default function CommunicationChannelsScreen() {
  const { t } = useTranslation()
  const { communication_channels, toggleCommunicationChannel } = useNeedsAnalysis()

  return (
    <CarouselItem className='px-2 sm:px-8'>
      <div className='space-y-2 py-2 sm:space-y-6 sm:py-6'>
        <div className='space-y-1 sm:space-y-2'>
          <h3 id='communication-channels-heading' className='text-base font-medium text-gray-900 sm:text-xl'>
            {t('needsAnalysis.communicationChannels.title')}
          </h3>
          <p id='communication-channels-hint' className='text-xs text-gray-600 sm:text-sm'>
            {t('needsAnalysis.communicationChannels.selectAll')}
          </p>
        </div>

        <div
          role='group'
          aria-labelledby='communication-channels-heading'
          aria-describedby='communication-channels-hint'
          className='space-y-2 sm:space-y-3'
        >
          {COMMUNICATION_CHANNELS.map((channel) => {
            const isSelected = communication_channels.includes(channel)
            return (
              <Label
                key={channel}
                htmlFor={`channel-${channel}`}
                className={`flex cursor-pointer items-center space-x-2 rounded-lg border p-2 transition-colors hover:bg-gray-50 sm:space-x-3 sm:p-4 ${
                  isSelected ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
                }`}
              >
                <Checkbox
                  id={`channel-${channel}`}
                  checked={isSelected}
                  onCheckedChange={() => toggleCommunicationChannel(channel)}
                />
                <span className='flex-1 text-sm font-medium sm:text-base'>
                  {t(`needsAnalysis.communicationChannels.options.${channel}`)}
                </span>
              </Label>
            )
          })}
        </div>
      </div>
    </CarouselItem>
  )
}
